import { render } from "./DesktopNavigation.vue?vue&type=template&id=6e826ae4&scoped=true"
import script from "./DesktopNavigation.vue?vue&type=script&lang=js"
export * from "./DesktopNavigation.vue?vue&type=script&lang=js"

import "./DesktopNavigation.vue?vue&type=style&index=0&id=6e826ae4&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e826ae4"]])

export default __exports__